import React from 'react';
import { Switch, Route } from 'react-router-dom';

import AddRP from './add-rp';
import ReserveRP from './reserve-rp'


import Error404 from '../Error404';


export default ({ match }) => {
    return (
        <Switch>
            <Route path={`${match.path}/add-rp`} component={AddRP} />
            <Route path={`${match.path}/reserve-rp`} component={ReserveRP} />
            <Route component={Error404} />
        </Switch>
    )
}
